import { Injectable } from '@angular/core';
import { HttpHeaders, HttpClient, HttpParams, HttpBackend } from '@angular/common/http';
// import { Observable, of, throwError } from 'rxjs';
import { catchError, map, tap, switchMap, take } from 'rxjs/operators';
// import { environment } from 'src/environments/environment';
import { environment } from 'environments/environment';

import { BehaviorSubject, Observable, pipe, of, throwError, Subject, forkJoin } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { NavigationService } from 'app/shared/services/navigation.service';
import { JwtAuthService } from './auth/jwt-auth.service';
import { config } from 'config';
import { AdditionalActionsType, BulkActionStatus, ORDER_STATUS_LABEL_MAPPING, OrderAssignStatusEnum, OrdersTableStatus, OrderStatusEnum } from '../helpers/status-options.helper';
import { createHttpParams, maskMobileNumber, utcToRelativeTime, utcToExactTime } from '../helpers/utils';
import { PaginatedData, PaginationRequest } from '../interfaces/pagination';
import { isSurveyDataObj, SurveyData, SurveyDataObj, SourceEnum, TELEHEALTH_BOOKING_TYPE } from '../models/surveyData.model';
import { Environment, NoteType } from '../interfaces/utility-types';
import { Flag } from '../helpers/utility-types';
import { Pharmacy } from '../models/pharmacy.model';
import { createCustomAuthHeader } from '../helpers/auth.helper';
import { CONFORMANCE_ID } from '../constants';
import { ProfileType } from '../enums/profile-type.enum';
import { PaymentStatusValue } from '../helpers/payment-status-map.helper';
import { ConsultOutcomeStatus } from 'app/views/orders/view-orders/view-orders.component';
import { DialogConfirmationComponent, ConfirmationDialogData } from 'app/views/orders/dialog-confirmation/dialog-confirmation.component';
import { AlertService } from 'app/shared/services/alert/alert.service';
import { prepareTime } from '../helpers/time.helper';
import moment, { Moment } from 'moment-timezone';
import { DialogWaitingRoomReasonComponent, WaitingRoomReasonResult } from 'app/views/orders/dialog-waiting-room-reason/dialog-waiting-room-reason.component';
import { SystemSettingsService, PortalFilterConfiguration } from './system-settings.service';
import { AddClinicianNoteComponent } from '../components/add-clinician-note/add-clinician-note.component';
import { DialogCreateFollowUpRequestComponent } from 'app/views/orders/dialog-create-follow-up-request/dialog-create-follow-up-request.component';
import { ClinicianService } from './clinician/clinician.service';
import { PendingCancellationActionDialogComponent, PendingCancellationActionData, PendingCancellationActionResult } from 'app/views/orders/pending-cancellation-action-dialog/pending-cancellation-action-dialog.component';
import { DialogCancelOrderComponent, CancelOrderDialogData } from 'app/views/orders/dialog-cancel-order/dialog-cancel-order.component';
import { DialogTrackingLinkComponent, TrackingLinkDialogData, TRACKING_LINK_SKIPPED } from 'app/views/orders/dialog-tracking-link/dialog-tracking-link.component';


export type OrderStatus =
  | 'Awaiting Authorisation'
  | 'Awaiting Delivery'
  | 'Awaiting Pickup'
  | 'Cancelled'
  | 'Clinic To Action'
  | 'Clinic To Review'
  | 'Completed'
  | 'Exception'
  | 'In Transit'
  | 'New'
  | 'Pending Batch Processing'
  | 'Pending Cancellation'
  | 'Pending Payment'
  | 'Pharmacy To Review'
  | 'Process'
  | 'Quote Request'
  | 'Rejected'
  | 'Repeat Order'
  | 'Request Issued'
  | 'Return'
  | 'Returned'
  | 'Waiting For Review'
  | 'Waiting Room'
  | 'Waiting For Info'
  | 'Clinic To Update'
  | 'Bulk Status Transition'
  | 'Pending Return'
  | 'Left At LPO'
  | 'Escalated'
  | 'Auto Allocation';

export interface TrackingLinkOrder {
  orderId: number;
  userId: number;
  isPickup: boolean;
}

// ordertype is stored as both 'Pickup' and 'Pick Up'
export function isPickupOrderType(orderType: string): boolean {
  return /^pick\s?up$/i.test((orderType || '').trim());
}

export interface OrderCountRequest {
  source?: string;
  location_id?: number;
  order_class?: string;
  order_status?: string;
}

export interface DeliveryPartner {
  partneroptionid: number;
  partnername: string;
  type: string;
  description: string;
  partnerimage: string | null;
  overwrite_deliveryfee: string | null;
  charge_delivery_partner_price: number;
  locationid: number;
  partnerstatus: number | null;
  deliverytext: string | null;
  deliveryestimate: string;
  estimateid: string;
  finaldeliveryfee: string;
  deliveryMessage: string;
  deliverypartnerid: number;
}

export interface ActiveDeliveryPartnersApiResponse {
  delivery_estimates: DeliveryPartner[];
  status: number;
}

export interface Subscription {
  name: string;
  cycle_number: number | null;
  cycle_start_date?: string | null;
  cycle_end_date?: string | null;
  cadence_days?: number | null;
  followup_lead_days?: number | null;
}


export interface OriginalScriptsListItem {
  prescriptionid: string;
  userid: number;
  drugname: string;
  created_at: string;
  updated_at: string;
  type: number;
  profileid: number;
  drugquantity: string;
  drugpack: string;
  orderbasketid: number;
  orderid: number;
  locationid: number;
  basketid: number;
  isgeneric: number;
  deliveryaddressid: number;
  matched_medmate_item_code: string;
  originalprice: string;
  script_fee: string;
  payment_id: number;
  // Add more properties with known types here
  // Optionally, you can mark the rest as optional using Partial<T>
  [key: string]: any; // Any additional properties not listed above can have any type
}

export interface PrescriptionItem {
  prescriptionid: string;
  userid: number;
  prescriptiontype: string;
  prescriptiontitle: string;
  prescriptionimage: string;
  prescriptionbackimage: string;
  prescriptionguid: string;
  prescriptionitemguid: string;
  barcode: string;
  drugname: string;
  prescriptiondate: string;
  repeats: string;
  expirydate: string;
  prescribertitle: string;
  prescriberfirstname: string;
  prescriberlastname: string;
  prescriptionstatus: string;
  created_at: string;
  updated_at: string;
  type: number;
  e_script_type: string;
  prescriptionitemid: string;
  referrencetable: string;
  prescriptionuserid: string;
  profileid: number;
  prescriptionfor: string;
  prescriptionissuer: string;
  drugstrength: string;
  drugform: string;
  drugquantity: string;
  drugpack: string;
  price: string;
  substitutionallowed: string;
  pbsitemno: string;
  pbsitemmc: string;
  amtitemno: string;
  drugdata: string;
  itemexpirydate: string;
  medilistid: string;
  ismedlist: string;
  medimage: string;
  mimsimage: string;
  isscript: any;
  cmicode: string;
  medstatus: string;
  itemschedule: string;
  script_url: string;
  dosage_instructions: string;
  issent: string;
  medviewtaskid: string;
  orderbasketid: number;
  orderid: number;
  locationid: number;
  basketid: number;
  drugspecification: string;
  isgeneric: number;
  drugstatus: string;
  drugInstructions: string;
  deliveryaddressid: number;
  medlistid: string;
  originalprice: string;
  discountedprice: string;
  deliveryinstructions: string;
  basketliststatus: string;
  itemimage: string;
  cardtype: string;
  istbc: string;
  previous_locationid: string;
  instance_id: string;
  locationstatus: number;
  matched_medmate_item_code: string;
}

export interface ChatbotConfig {
  title?: string;
  script?: string;
}

export interface OrderDetail {
  orderTrackingDetails: OrderTackingDetails[];
  orderHistory: unknown[];
  order_service_profiles?: number[];
  chatbot_config?: ChatbotConfig[];
  orderData: {
    redemption_amount: any;
    order_assign_status: OrderAssignStatusEnum;
    consult_outcome: ConsultOutcomeStatus;
    subTotal: number;
    status_code: any;
    latitude: any;
    longitude: any;
    orderShiftId: any;
    orderBalance: string;
    script_fee: any;
    orderPaidAmount: number;
    preferred_pharmacy: any;
    paid_online: any;
    paid_in_store: any;
    deliveryPartnerId: any;
    myuserid: number;
    fname: string;
    lname: string;
    emailaddress: string;
    gender: string;
    mobilenumber: string;
    dateofbirth: string;
    orderid: number;
    uniqueorderid: number;
    enduserid: number;
    locationid: number;
    deliveryaddressid: number;
    orderprice: string;
    deliveryfee: string;
    customerServiceFee: string;
    finalprice: string;
    orderstatus: OrderStatus;
    orderTotal: string;
    ordertype: string;
    userpreffereddate: string;
    userprefferedtime: string;
    paymentstatus: PaymentStatusValue;
    paymenttype: string;
    orderinstructions: string;
    isGeneric: string;
    speakwithpharmacist: string;
    orderDate: string;
    transactionId: string;
    driverinstructions: string;
    deliveryinstructions: string;
    AdditionalDeliveryInstructions: string;
    pickupinstructions: string;
    deliverypartnername: string;
    estimateid: string;
    partner_deliveryid: string;
    delivery_tracking: string;
    isnew: number;
    created_at: string;
    updated_at: string;
    invoice_id: string;
    isdeliveryapply: number;
    type: number;
    previous_locationid: string;
    fulfilling_pharmacy?: number;
    Source: string;
    currentOwner: string;
    medmateOrderNotes: string;
    pharmacyOrderNotes: string;
    clinician_notes?: string;
    video_consultation_link?: string;
    coviu_room?: string | null;
    MembershipNumber: string;
    rating: number;
    ratingComment: string;
    isShow: number;
    notify: number;
    orderAccepted: number;
    uberOrderId: string;
    myorderstatus: OrderStatus;
    deliverypartner: string;
    statustime: string;
    locationname: string;
    address: string;
    postcode: string;
    logo: string;
    phone: string;
    locationstatus: number;
    timings: string;
    salesNotes: string;
    target: string;
    addr1: string;
    deliverymobile: string;
    addr2: string;
    addsuburb: string;
    addstate: string;
    addpostcode: string;
    subscription: Subscription | null;
    order_remarks: string;
    source_domain: string;
    order_class: string;
    assignedClincian?: assignedClincianDetails;


    paper_script_email_sent: string;
    paper_script_location_has_email: boolean;
    paper_script_location: number | null;
    isPaperScriptAdded: boolean;
    survey_data?: string;
    booking_time?: string;
    booking_time_zone?: string;
    requested_doctor_name?: string;
    order_service_profiles?: number[];
    has_pending_data_form?: boolean;
  };
  healthprofile: [
    {
      profileid: number;
      userid: number;
      gpname: string;
      gplink: string;
      gpclinicname: string;
      gpclinicaddressline1: string;
      gpclinicaddressline2: string;
      gpclinicsuburb: string;
      gpclinicstate: string;
      gpclinicpostcode: string;
      gpclinicphone: string;
      ismedicare: string;
      medicarenumber: string;
      medicarenumberpos: string;
      medicare_exp: string;
      heathcarecard: string;
      pensionerconcessioncard: string;
      concessionsafetynetcard: string;
      healthfundname: string;
      healthfundmembershipnumber: string;
      healthfundmembershipreferencenumber: string;
      ihi: string;
      ihi_exp: string;
      dvano: string;
      dvanoexp: string;
      veteranaffairsnumber: string;
      veteranaffairsexp: string;
      safetynet: string;
      anyallergies: string;
      allergies: string;
      medicalconditions: string;
      pregnency: number;
      expectedduedate: string;
      lactation: number;
      smoking: number;
      oncontraception: number;
      nameofcontraception: string;
      weight: string;
      medicalprocedure: string;
      descriptionforprocedure: string;
      procedureyear: string;
      parentuser_flag: number;
      profile_relation: string;
      created_at: string;
      updated_at: string;
      opv_checked_date: string;
      medicarestatus: number;
      concessionstatus: number;
    }
  ];
  useraddress: [];
  scriptslist: PrescriptionItem[];
  originalscriptslist: OriginalScriptsListItem[];
  deliveryPartnerNames: [
    {
      partnername: string;
    },
    {
      partnername: string;
    }
  ];
  survey_data: SurveyData[];
  consult_history?: ConsultHistory[];
  data_forms?: DataForm[];
}

export enum DataFormStatus {
  Pending = 'pending',
  Submitted = 'submitted',
  Expired = 'expired',
}

export interface DataFormQuestion {
  id: string;
  type: string;
  label: string;
  hint?: string;
  placeholder?: string;
  options?: string[];
  required?: boolean;
  accept?: string;
  multiple?: boolean;
  section?: string;
  section_hint?: string;
  section_type?: string;
}

export interface DataFormRequestedBy {
  userid: number;
  firstname: string;
  lastname: string;
  title?: string;
}

export interface DataForm {
  id: number;
  order_id: number;
  title?: string;
  questions: DataFormQuestion[];
  answers: Record<string, unknown> | null;
  status: DataFormStatus;
  requested_by: DataFormRequestedBy | number;
  submitted_at?: string;
  expires_at?: string;
  form_link?: string;
  created_at: string;
  updated_at: string;
}

export interface OrderTackingDetails {
  changedBy: string;
  changedAt: string;
  statusName: string;
  isCurrentStatus: boolean;
  remarks: string;
}

export interface ConsultHistory {
  date_time: string;
  clinician_name: string;
  start_time?: string;
  end_time?: string;
  status: string;
  consult_outcome?: string;
  time_spent: string | number;
  number_of_pauses: string | number;
  reason?: string;
  is_current_owner: boolean;
  created_at: string;
  updated_at: string;
}


export interface OrderList {
  name: string;
  value: string;
}
export interface Address {
  firstName: string;
  lastName: string;
  email: string;
  Address: string;
  mobilenumber?: string;
  addressLine1: string;
  addressLine2: string;
  suburb: string;
  state: string;
  postcode: string;
  uniqueorderid?: string;
}

export interface PatientAddress {
  street_address: string;
  suburb: string;
  postcode: string;
}
export interface Items {
  itemDetails: string;
  unitPrice: number;
  quantity: number;
  price: string;
}
export interface Scripts {
  prescriptionid: string;
  userid: number;
  prescriptiontype: string;
  prescriptiontitle: string;
  prescriptionimage: string;
  prescriptionbackimage: string;
  prescriptionguid: string;
  prescriptionitemguid: string;
  barcode: string;
  drugname: string;
  prescriptiondate: string;
  repeats: string;
  expirydate: string;
  prescribertitle: string;
  prescriberfirstname: string;
  prescriberlastname: string;
  prescriptionstatus: string;
  created_at: string;
  updated_at: string;
  type: number;
  e_script_type: string;
  prescriptionitemid: string;
  referrencetable: string;
  prescriptionuserid: string;
  profileid: number;
  prescriptionfor: string;
  prescriptionissuer: string;
  drugstrength: string;
  drugform: string;
  drugquantity: string;
  drugpack: string;
  price: string;
  substitutionallowed: string;
  pbsitemno: string;
  pbsitemmc: string;
  amtitemno: string;
  drugdata: string;
  itemexpirydate: string;
  medilistid: string;
  ismedlist: string;
  medimage: string;
  mimsimage: string;
  isscript: string;
  cmicode: string;
  medstatus: string;
  itemschedule: string;
  script_url: string;
  dosage_instructions: string;
  issent: string;
  medviewtaskid: string;
  orderbasketid: number;
  orderid: number;
  locationid: number;
  basketid: number;
  drugspecification: string;
  isgeneric: number;
  drugstatus: string;
  drugInstructions: string;
  deliveryaddressid: number;
  medlistid: string;
  originalprice: string;
  discountedprice: string;
  deliveryinstructions: string;
  basketliststatus: string;
  itemimage: string;
  cardtype: string;
  istbc: string;
  previous_locationid: string;
  instance_id: string;
  locationstatus: number;
}

export interface OrderDetails {
  external_reference_id: string;
  date: string;
  orderNumber: number;
  status: string;
  from: string;
  bookingTime?: Moment;
  bookingTimezone?: string;
  requestedDoctorName?: string;
}

export interface orderRemarks {
  show: boolean;
  remarks: OrderDetail['orderData']['order_remarks'];
}

export interface AssignedClincian {
  id?: number;
  name: string;
  shiftId: number;
  number_of_active_orders?: number;
  in_consult?: 0 | 1;
  billing_profile?: 'hour' | 'consult';
}

export interface AvailableClinician {
  id: number;
  name: string;
  shiftId: number;
  number_of_active_orders?: number;
  in_consult?: 0 | 1;
  billing_profile?: 'hour' | 'consult';
  experience?: string;
  max_consult_allocation?: number;
  bat_appointments?: Array<{ order_id: number; time: string }>;
  number_of_pharmacy_consults?: number;
  number_of_priority_consults?: number;
  out_of_scope_escalated_orders?: number[];
}

export interface ClinicianDetails {
  availableClinicians?: AvailableClinician;
  assignedClincian?: AssignedClincian
}


export interface assignedClincianDetails {
  id?: number;
  name: string;
}

export interface PatientDetails {
  name: string;
  firstName: string;
  lastName: string;
  dob: string;
  sex: string;
  address: PatientAddress
  medicare: string;
  mobile: string;
  maskedMobileNumber: string;
}
export interface Tile {
  color?: string;
  cols?: number;
  rows?: number;
  text?: string;
  date?: string;
  status?: string;
  order: number;
  orderNumber?: number;
  instructions?: string;
  customerDetails?: Address;
  patientDetails?: PatientDetails;
  website?: string;
  senderDetails?: sender;
  child?: child;
  pharmInstruction?: instructions;
  orderDetails?: OrderDetails;
  adminNotes?: any;
  pharmacyOrderNotes?: PharmacyOrderNotes;
  orderInstructions?: OrderInstructions;
  additionalDeliveryInstructions?: any;
  orderRemarks?: orderRemarks;
  assignedClincian?: assignedClincianDetails;
  ClinicianDetails?: ClinicianDetails;
}

export interface OrderInstructions {
  orderInstructions: string;
}

export enum TileType {
  OrderDetails = 'Order Details',
  PatientDetails = 'Patient Details',
  CustomerDetails = 'Customer Details',
  SenderDetails = 'Sender Details',
  PharmacyInstructions = 'Pharmacy Instructions',
  PharmacyOrderNotes = 'Pharmacy Order Notes',
  AdditionalDeliveryInstructions = 'Additional Delivery Instructions',
  OrderInstructions = 'Order Instructions',
  OrderRemarks = 'Order Remarks',
  ClinicianDetails = 'Clinician Details',
}


export interface sender {
  locationname: string;
  address: string;
  postcode: string;
  phone: string;
  locationid: any;
  locationstatus: any;
  times: any;
}
export interface child {
  textChild: string;
  id: number;
}
export interface instructions {
  pickupinstructions: string;
  anyallergies: string;
  pharmacyOrderNotes: string;
}
export interface PharmacyOrderNotes {
  pharmacyOrderNotes?: string;
}

export interface PrecheckoutOrderPayload {
  locationid: number;
  cartitems: CartItem[];
  deliveryaddressid: number;
  ordertotal: number;
  type: number;
  Source: string;
}

export interface CartItem {
  cartid: number;
  enduserid: number;
  userid: number;
  profileid: number;
  prescriptionid: string;
  matched_medmate_item_code: string;
  referrencetable: string;
  prescriptiontype: string;
  prescriptionname: string;
  medlistid: string;
  prescriptionfor: string;
  name: string;
  quantity: string;
  drugpack: string;
  cartprice: string;
  strength: string;
  form: string;
  image: string;
  scriptavailable: number;
  itemgrouptype: string;
  itemschedule: string;
  cartstatus: number;
  created_at: string;
  updated_at: string;
  cardtype: number;
  istbc: string;
  locationid: number;
  isgeneric: number;
  type: number;
  Source: string;
  promotion_id: string;
  script_url: string;
}

export interface PrecheckoutAPIResponse {
  customerServiceFee: string;
  small_order_fee: string;
  gateways: PaymentGateway[];
  cartitems: CartItem[];
  msg: string;
  istbc: number;
  price_change_msg: string;
  status: number;
}

export interface PaymentGateway {
  payment_gateway_id: number;
  payment_gateway_name: string;
  minimum_amount: string;
}

export interface ActiveDeliveryPartnersPayload {
  order_id: number;
}

export interface UserSearchResult {
  userid: number;
  username: string;
  firstname: string;
  lastname: string | null;
  mobile: string | null;
  profiletypeid: string;
  currentAddress: {};
  location_id?: number;
  location_name?: string;
  business_id?: string;
  business_name?: string;
  business_ids?: number[];                                  // MT-831
  businesses?: { business_id: number; business_name: string }[];  // MT-831
}

export interface Link {
  name: string;
  url: string;
}

export interface AssignableMedication {
  id: number;
  medication_name: string;
  updated_at: string;
  created_at: string;
}

export interface DeliveryData {
  locationid: number;
  deliveryaddressid: number;
  ordertotal: number;
  source?: string;
  check_soh?: Flag;
}

export interface AssignableMedicationProdPayload {
  tokens: string[];
}

export interface AssignableMedicationDevPayload {
  assignable_medication_id: number;
}

export type AssignableMedicationPayloadWithEnv = {
  env: Environment;
} & AssignableMedicationPayload;

export type AssignableMedicationPayload =
  | AssignableMedicationProdPayload
  | AssignableMedicationDevPayload;

export enum OrderStatusCodeEnum {
  Healthy = 200,
  StatusChangeError = 410,
  NoActiveItems = 411,
  EmptyBasket = 412,
  SystemError = 500
}
export interface StatusCodeDetails {
  name: string;
  colour: string;
}

export type OrderStatusCodes = Record<OrderStatusCodeEnum, StatusCodeDetails>;

export interface ActivateInactiveBasketItemsPayload {
  order_id: number;
  item_ids: number[];
}
export interface ActivateInactiveBasketItemsResponse {
  msg: string;
  status: number;
}
export interface PharmacyListRequestParams {
  statuses?: string;    // Comma-separated list of statuses
  segments?: string;    // Comma-separated list of segments
  business_id?: string;
}
export interface SearchUserPayload {
  searchTerm: string;
  profile_type_ids?: string; //comma separted ids
  locationId?: number
}

export interface OrdersAutoAllocationResponse {
  msg: string;
  noClinicaiansAvailable: number;
  noActiveShift: number;
  allocationError: number;
  status: string;
}

export interface SearchUserPayload {
  searchTerm: string;
  profile_type_ids?: string; //comma separted ids
  locationId?: number
}
export interface PharmacyListRequestParams {
  statuses?: string;    // Comma-separated list of statuses
  segments?: string;    // Comma-separated list of segments
  business_id?: string;
}

export interface AddPaperScriptLocationRequest {
  order_id: number;
  location_id: number;
}
export interface AddPaperScriptLocationResponse {
  message: string;
}
@Injectable({ providedIn: 'root' })
export class DataOrderService {
  newScript: Scripts[];
  subject = new Subject();
  private cachedOrderSources: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);
  private cachedPharmacies: BehaviorSubject<Pharmacy[]> = new BehaviorSubject<Pharmacy[]>([]);
  private cachedClinicians: BehaviorSubject<any[]> = new BehaviorSubject<any[]>([]);

  serviceResponse: OrderDetail;
  tiles: Tile[] = [
    {
      text: TileType.OrderDetails,
      cols: 1,
      rows: 1,
      order: 0,
      color: 'white',
      orderDetails: {
        date: '',
        orderNumber: null,
        status: '',
        from: '',
        external_reference_id: ''
      },
    },
    {
      text: TileType.SenderDetails,
      cols: 1,
      rows: 1.5,
      color: 'white',
      senderDetails: {
        locationname: '',
        address: '',
        postcode: '',
        phone: '',
        locationid: '',
        locationstatus: 0,
        times: '',
      },
      order: 1
    },
    {
      text: TileType.PharmacyInstructions,
      cols: 1,
      rows: 1,
      color: '#f1f1f1',
      pharmInstruction: {
        pickupinstructions: '',
        anyallergies: '',
        pharmacyOrderNotes: '',
      },
      order: 2
    },
    {
      text: TileType.CustomerDetails,
      cols: 1,
      rows: 1.5,
      color: 'white',
      customerDetails: {
        firstName: '',
        email: '',
        lastName: '',
        Address: '',
        addressLine1: '',
        addressLine2: '',
        suburb: '',
        state: '',
        postcode: '',
        mobilenumber: '',
      },
      order: 3
    },
    {
      text: TileType.AdditionalDeliveryInstructions,
      cols: 1,
      rows: 1.5,
      additionalDeliveryInstructions: '',
      order: 5
    },
    {
      text: TileType.OrderInstructions,
      cols: 1,
      rows: 1.5,
      orderInstructions: {
        orderInstructions: '',
      },
      order: 6
    },
    {
      text: TileType.OrderRemarks,
      cols: 1,
      rows: 1.5,
      orderRemarks: {
        show: false,
        remarks: ''
      },
      order: 7
    },
    {
      text: TileType.PatientDetails,
      cols: 1,
      rows: 1.5,
      color: 'white',
      patientDetails: {
        name: '',
        dob: '',
        sex: '',
        medicare: '',
        address: {
          street_address: '',
          suburb: '',
          postcode: ''
        },
        firstName: '',
        lastName: '',
        mobile: '',
        maskedMobileNumber: ''
      },
      order: 4
    },
    {
      text: TileType.ClinicianDetails,
      cols: 1,
      rows: 1.5,
      color: 'white',
      order: 8,
      ClinicianDetails: {}

    },
    {
      text: 'Assigned To',
      cols: 1,
      rows: 1.5,
      order: 9,
      assignedClincian: {
        name: "",
        id: 0
      }
    }
  ];
  listItems: OrderList[] = [
    {
      name: 'Sub Total',
      value: '',
    },

    {
      name: 'Delivery Fee',
      value: '',
    },
    {
      name: 'Service Fee',
      value: '',
    },
    {
      name: 'Order Total',
      value: '',
    },
  ];

  newOrderDetails: OrderDetail;

  constructor(
    private http: HttpClient,
    private httpBackend: HttpBackend,
    public ns: NavigationService,
    private jwtAuth: JwtAuthService,
    private dialog: MatDialog,
    private alertService: AlertService,
    private systemSettingsService: SystemSettingsService,
    private clinicianService: ClinicianService
  ) { }

  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getOrderList(data): Observable<any[]> {
    let searchParams = {
      status: data.statuses,
      type: data.type,
      perPage: data.perPage,
      page: data.page,
    };

    if (data.clinician_order_status) {
      searchParams['clinician_order_status'] = data.clinician_order_status
    }

    if (typeof data.orderClass !== 'undefined') {
      searchParams['orderClass'] = data.orderClass;
    }

    if (typeof data.filter !== 'undefined') {
      searchParams['filter'] = data.filter;
    }

    if (data.start_date && data.end_date) {
      searchParams['start_date'] = data.start_date;
      searchParams['end_date'] = data.end_date;
    }

    if (typeof data.use_clinician_report_filter !== 'undefined') {
      searchParams['use_clinician_report_filter'] = data.use_clinician_report_filter;
    }

    if (data.clinicianId) {
      searchParams['clinician_id'] = data.clinicianId;
    }

    return this.http
      .get<any>(environment.apiURL + 'getOrderStatus', {
        params: searchParams,
        responseType: 'json',
      })
      .pipe(
        switchMap(response => {
          this.ns.getOrderCountForMenu();
          return of(response);
        }),
        catchError(this.handleError('error getAllorders', [])));
  }

  getPharmacyList(data: PharmacyListRequestParams): Observable<Pharmacy[]> {
    if (this.cachedPharmacies.value.length > 0) {
      return this.cachedPharmacies.asObservable().pipe(take(1));
    }

    if (this.jwtAuth.isBusiness()) {
      data.business_id = this.jwtAuth.getUser().businessid;
    }
    const params = createHttpParams(data);
    return this.http
      .get<Pharmacy[]>(`${environment.apiURL}getListofActivePharmacies`, {
        params,
        responseType: 'json',
      })
      .pipe(
        tap(pharmacies => {
          if (pharmacies && pharmacies.length > 0) {
            this.cachedPharmacies.next(pharmacies);
          }
        }),
        switchMap(() => this.cachedPharmacies.asObservable().pipe(take(1))),
        catchError(error => {
          console.error('Failed to fetch pharmacies:', error);
          return of([]);
        })
      );
  }

  upsertCachedPharmacy(pharmacy: Partial<Pharmacy>): void {
    if (!pharmacy?.locationid) {
      return;
    }

    const cachedPharmacies = this.cachedPharmacies.value || [];
    if (!cachedPharmacies.length) {
      return;
    }

    const locationId = Number(pharmacy.locationid);
    const existingIndex = cachedPharmacies.findIndex(item => Number(item.locationid) === locationId);
    const nextPharmacyList = cachedPharmacies.slice();

    if (existingIndex >= 0) {
      nextPharmacyList[existingIndex] = {
        ...nextPharmacyList[existingIndex],
        ...pharmacy,
      } as Pharmacy;
    } else {
      nextPharmacyList.push(pharmacy as Pharmacy);
    }

    this.cachedPharmacies.next(nextPharmacyList);
  }

  getCliniciansForFilter(): Observable<any[]> {
    if (this.cachedClinicians.value.length > 0) {
      return this.cachedClinicians.asObservable().pipe(take(1));
    }

    return this.clinicianService.getClinicians().pipe(
      tap(response => {
        if (response && response.clinicians && response.clinicians.length > 0) {
          this.cachedClinicians.next(response.clinicians);
        }
      }),
      switchMap(() => this.cachedClinicians.asObservable().pipe(take(1))),
      catchError(error => {
        console.error('Failed to fetch clinicians for filter:', error);
        return of([]);
      })
    );
  }

  getLabels(data): Observable<Blob> {
    const headers = new HttpHeaders();
    headers.set('Accept', 'application/pdf');
    headers.set('Content-Type', 'application/pdf');
    return this.http.get(environment.apiURL + 'label', {
      headers: headers,
      params: data,
      responseType: 'blob',
    });
  }

  getSalesReport(data?): Observable<any[]> {
    // return this.http.get<any>(config.apiUrl2,
    return this.http
      .get<any>(environment.apiURL + 'getSalesSummaryReport', {
        params: data,
        responseType: 'json',
      })
      .pipe(
        tap(heroes => console.log('Generating Sales Reports...')),
        catchError(this.handleError())
      );
  }

  setViewOrder(order: OrderDetail) {
    this.newOrderDetails = order;
    //order details tile
    this.tiles[0].orderDetails.date = this.newOrderDetails.orderData.orderDate;
    this.tiles[0].orderDetails.orderNumber = this.newOrderDetails.orderData.uniqueorderid;
    this.tiles[0].orderDetails.status = this.newOrderDetails.orderData.myorderstatus;
    this.tiles[0].orderDetails.from = this.newOrderDetails.orderData.Source;
    this.tiles[0].orderDetails.external_reference_id = this.newOrderDetails.orderData?.uberOrderId;

    let bookingTimeStr = this.newOrderDetails.orderData?.booking_time;
    let isFromSurveyData = false;

    if (!bookingTimeStr) {
      try {
        const surveyData = this.prepareSurveyData(this.newOrderDetails.survey_data);
        if (surveyData?.header?.appointment_slot) {
          bookingTimeStr = surveyData.header.appointment_slot;
          isFromSurveyData = true;
        }
      } catch (error) {
        console.warn('Error extracting appointment_slot from survey_data:', error);
      }
    }

    if (bookingTimeStr) {
      const preparedTime = isFromSurveyData
        ? moment(bookingTimeStr)
        : prepareTime(bookingTimeStr, this.jwtAuth.getRole());
      this.tiles[0].orderDetails.bookingTime = preparedTime;
    } else {
      this.tiles[0].orderDetails.bookingTime = null;
    }

    if (this.jwtAuth.isAdmin()) {
      const surveyDataForDoctor = this.prepareSurveyData(this.newOrderDetails.survey_data);
      this.tiles[0].orderDetails!.requestedDoctorName =
        this.newOrderDetails.orderData?.requested_doctor_name ||
        surveyDataForDoctor?.header?.requested_doctor_name ||
        undefined;
    }

    //pharmacy details tile
    this.tiles[1].senderDetails.locationname = this.newOrderDetails.orderData.locationname;
    this.tiles[1].senderDetails.address = this.newOrderDetails.orderData.address;
    this.tiles[1].senderDetails.phone = this.newOrderDetails.orderData.phone;
    this.tiles[1].senderDetails.postcode = this.newOrderDetails.orderData.postcode;
    this.tiles[1].senderDetails.locationstatus = this.newOrderDetails.orderData.locationstatus;
    this.tiles[1].senderDetails.times = this.newOrderDetails.orderData.timings;

    //pharmacy instructions tile
    this.tiles[2].pharmInstruction.pickupinstructions =
      this.newOrderDetails.orderData.pickupinstructions;
    this.tiles[2].pharmInstruction.anyallergies = this.parseJson(
      this.newOrderDetails.healthprofile[0].allergies
    );

    //customer details tile
    this.tiles[3].customerDetails.firstName = this.newOrderDetails.orderData.fname;
    this.tiles[3].customerDetails.lastName = this.newOrderDetails.orderData.lname;
    this.tiles[3].customerDetails.email = this.newOrderDetails.orderData.emailaddress;
    this.tiles[3].customerDetails.Address = this.newOrderDetails.orderData.address;
    this.tiles[3].customerDetails.mobilenumber = this.newOrderDetails.orderData.mobilenumber;
    this.tiles[3].customerDetails.addressLine1 = this.newOrderDetails.orderData.addr1;
    this.tiles[3].customerDetails.addressLine2 = this.newOrderDetails.orderData.addr2;
    this.tiles[3].customerDetails.suburb = this.newOrderDetails.orderData.addsuburb;
    this.tiles[3].customerDetails.state = this.newOrderDetails.orderData.addstate;
    this.tiles[3].customerDetails.postcode = this.newOrderDetails.orderData.addpostcode;

    //assignClinician details
    if (this.newOrderDetails.orderData?.assignedClincian?.name) {
      this.tiles[9].assignedClincian.name = this.newOrderDetails.orderData.assignedClincian.name;
      this.tiles[9].assignedClincian.id = this.newOrderDetails.orderData.assignedClincian.id;
    }
    //additional delivery instructions
    this.tiles[4].additionalDeliveryInstructions = this.newOrderDetails.orderData
      .AdditionalDeliveryInstructions
      ? this.newOrderDetails.orderData.AdditionalDeliveryInstructions
      : 'No additional instructions';

    //order notes from user
    this.tiles[5].orderInstructions.orderInstructions =
      this.newOrderDetails.orderData.orderinstructions;

    //payment list items
    this.listItems[3].value = this.newOrderDetails.orderData.orderTotal;
    this.listItems[1].value = this.newOrderDetails.orderData.deliveryfee;
    this.listItems[2].value = this.newOrderDetails.orderData.customerServiceFee;

    //Order Remarks
    const { order_remarks, myorderstatus } = this.newOrderDetails.orderData;
    const relevantStatuses = [OrderStatusEnum.PendingCancellation, OrderStatusEnum.Rejected, OrderStatusEnum.Cancelled];
    this.tiles[6].orderRemarks = {
      show: order_remarks && relevantStatuses.includes(myorderstatus),
      remarks: order_remarks
    };

    //patient details tile
    const surveyData = this.prepareSurveyData(order.survey_data);
    if (isSurveyDataObj(surveyData)) {
      const userData = surveyData?.header?.user_data;
      const address = userData?.address;
      this.tiles[7].patientDetails = {
        name: `${userData.first_name ?? ''} ${userData.last_name ?? ''}`.trim(),
        firstName: userData.first_name ?? '',
        lastName: userData.last_name ?? '',
        dob: userData.date_of_birth
          ? `${userData.date_of_birth.date ?? '--'}/${userData.date_of_birth.month ?? '--'}/${userData.date_of_birth.year ?? '--'}`
          : '--/--/----',
        sex: userData.gender ?? 'Unknown',
        address: address,
        medicare: userData?.medicare_details?.status?.toString() === '1' ? 'Yes' : 'No',
        mobile: userData.mobile ?? '',
        maskedMobileNumber: userData.mobile ? maskMobileNumber(userData.mobile) : ''
      };
    }
  }

  prepareSurveyData(surveyData: any): SurveyDataObj | null {
    try {
      return JSON.parse(surveyData[0].survey_data).survey_data;
    } catch (error) {
      return null;
    }
  }

  getOrderdetails(id: number) {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('orderid', id);
    return this.http
      .get<OrderDetail>(environment.apiURL + 'getOrderDetails', {
        params: searchParams,
        responseType: 'json',
      })
      .pipe(
        tap(heroes => console.log('Fetching Order Details...')),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getViewOrderList(id): Observable<any[]> {
    let searchParams = new HttpParams();
    searchParams = searchParams.append('status', 'Completed,Cancelled');
    searchParams = searchParams.append('userid', id);

    // searchParams = searchParams.append("accepted", "1")
    return this.http
      .get<any>(environment.apiURL + 'getOrderStatus', {
        params: searchParams,
        responseType: 'json',
      })
      .pipe(catchError(this.handleError('error getAllorders', [])));
  }
  //TODO delete this edit order
  editOrder(bodyData: any): Observable<any> {
    return this.http.post<any>(environment.apiURL + 'editOrder', bodyData);
  }

  //secondary edit order
  _editOrder(bodyData: any): Observable<any> {
    return this.http.post<any>(environment.apiURL + 'editOrder', bodyData).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  addToCart(data, token) {
    const httpOptions = {
      headers: createCustomAuthHeader(token)
    };
    return this.http
      .post<any>(environment.apiURL1 + 'addtoCart', data, httpOptions)
      .toPromise();
  }

  getCart(token) {
    const httpOptions = {
      headers: createCustomAuthHeader(token),
    };
    return this.http
      .get<any>(environment.apiURL1 + 'getCartItems?type=2', httpOptions)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  getDeliveryPartners(data: DeliveryData, token: string): Observable<any> {
    const httpOptions = {
      params: createHttpParams(data),
      headers: createCustomAuthHeader(token),
    };
    return this.http
      .get<any>(environment.apiURL1 + 'getdeliverypartners', httpOptions)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  changeOrderStatus(
    orderid: number,
    fromstatus: any,
    status: any,
    remark: any
  ): Observable<any> {
    // this.tiles[1].status=status;
    //console.log('Two diff status', fromstatus, status, orderid)

    const bodyData = {
      orderid: orderid,
      fromstatus: fromstatus,
      status: status,
      remarks: remark || '',
    };
    return this.http
      .post<any>(environment.apiURL + 'changeOrderStatus', bodyData)
      .pipe(catchError(this.handleError('error getAllorders', [])));
  }

  _changeOrderStatus(
    orderid: number,
    fromstatus: any,
    status: any,
    remark: any,
    extraParams?: { refund?: boolean }
  ): Observable<any> {
    const bodyData: any = {
      orderid: orderid,
      fromstatus: fromstatus,
      status: status,
      remarks: remark || '',
    };
    if (extraParams?.refund !== undefined) {
      bodyData['refund'] = extraParams.refund;
    }
    return this.http.post<any>(environment.apiURL + 'changeOrderStatus', bodyData).pipe(
      switchMap(response => {
        this.ns.getOrderCountForMenu();
        return of(response);
      }),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  /**
   * Update priority escalation for an order (move to urgent)
   * @param orderId - The order ID to escalate
   * @returns Observable of the API response
   */
  updatePriorityEscalation(orderId: number): Observable<any> {
    const payload = { order_id: orderId };
    return this.http.post<any>(environment.apiURL1 + 'updatePriorityEscalation', payload).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  /**
   * Common method to show confirmation dialog and move order to urgent status
   * @param orderId - The order ID to move
   * @param currentStatus - Current status of the order (deprecated - kept for backwards compatibility)
   * @param onSuccess - Callback function to execute on successful move (optional)
   * @param onError - Callback function to execute on error (optional)
   * @param onCancel - Callback function to execute when dialog is cancelled (optional)
   */
  moveOrderToUrgent(
    orderId: number,
    currentStatus?: string,
    onSuccess?: () => void,
    onError?: (error: any) => void,
    onCancel?: () => void
  ): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '400px',
      data: {
        headerText: 'Move Order to Urgent?',
        message: 'This will move the order to the Urgent tab for immediate attention. The order will be prioritized for clinician assignment.',
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result == 1) {
        // Call the updatePriorityEscalation API method
        this.updatePriorityEscalation(orderId).subscribe(
          res => {
            this.alertService.notifySuccess('Order moved to Urgent successfully');

            // Execute success callback if provided
            if (onSuccess) {
              onSuccess();
            }
          },
          err => {
            this.alertService.notifyError(err.error?.msg || 'Failed to move order to Urgent');

            // Execute error callback if provided
            if (onError) {
              onError(err);
            }
          }
        );
      } else {
        // Dialog was cancelled - execute cancel callback if provided
        if (onCancel) {
          onCancel();
        }
      }
    });
  }

  searchData(name: any, locationid: any, source: any): Observable<any> {
    // this.tiles[1].status=status;
    console.log('Two diff status', name, locationid);

    const bodyData = { medication: name, locationid: locationid, Source: source };
    return this.http
      .post<any>(environment.apiURL1 + 'storesearch', bodyData)
      .pipe(catchError(this.handleError('error getAllorders', [])));
  }

  searchUser(data: SearchUserPayload) {
    const params = createHttpParams(data)
    return this.http
      .get<UserSearchResult[]>(environment.apiURL1 + 'searchUser', { params })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  addPrescription(data): Observable<any> {
    const dataWithConformanceId = {
      ...data,
      conformance_id: CONFORMANCE_ID  // Add CONFORMANCE_ID
    };
    return this.http.post<any>(environment.apiURL1 + 'addPrescriptionv2', dataWithConformanceId).pipe(
      tap(heroes => console.log('adding script')),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  addPrescriptionV2(data, token): Observable<any> {
    const dataWithConformanceId = {
      ...data,
      conformance_id: CONFORMANCE_ID  // Add CONFORMANCE_ID
    };
    const headers = createCustomAuthHeader(token);
    return this.http
      .post<any>(environment.apiURL1 + 'addPrescriptionsv2', data, { headers })
      .pipe(
        tap(heroes => console.log('adding script')),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  reorderRepeatScripts(data): Observable<any> {
    return this.http.post<any>(environment.apiURL1 + 'reorder_repeat_scripts', data).pipe(
      tap(heroes => console.log('reorder repeat script')),
      catchError(err => {
        return throwError(err);
      })
    );
  }

  addDeliveryAddress(data, token): Observable<any> {
    const headers = createCustomAuthHeader(token);
    return this.http
      .post<any>(environment.apiURL1 + 'addDeliveryAddress', data, { headers })
      .pipe(
        tap(heroes => console.log('Adding Delivery Address...')),
        catchError(err => {
          return throwError(err);
        })
      );
  }

  placeOrder(data, token: string, skipSource: boolean = false): Observable<any> {
    const headers = createCustomAuthHeader(token, skipSource);
    return this.http
      .post<any>(environment.apiURL1 + 'placeOrder', data, { headers })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  changePharmacy(orderid, prevlocation, locationid): Observable<any[]> {
    const bodyData = { orderid: orderid, prevlocation: prevlocation, locationid: locationid };
    return this.http
      .post<any>(environment.apiURL + 'changePharmacy', bodyData)
      .pipe(catchError(this.handleError('error getAllorders', [])));
  }
  fullRefund(id: number) {
    const bodyData = { orderid: id };

    return this.http.post<OrderDetail>(environment.apiURL + 'fullRefund', bodyData).pipe(
      tap(heroes => console.log('Fetching Order Details...')),
      catchError(this.handleError('error getting order details', []))
    );
  }

  initiateRefund(data) {
    return this.http.post(`${config.apiUrl1}initiateRefund`, data).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  confirmInStorePayment(data) {
    return this.http.post(`${config.apiUrl1}add_in_store_payment`, data).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  confirmManualPayment(data) {
    return this.http.post(`${config.apiUrl}addManualPayment`, data).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getAllOrders(params): Observable<any> {
    console.log('params', params);
    return this.http.get(environment.apiURL + 'getOrderStatus', { params: params }).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  sendToMedViewFlow(params): Observable<any> {
    // console.log('params', params)
    return this.http.post(environment.apiURL + 'sendToMedviewFlow', params).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  parseJson(data) {
    try {
      return JSON.parse(data);
    } catch (error) {
      return data;
    }
  }

  /**
   * Resubmit telehealth form
   * @param id The id to resubmit form
   * @returns Observable
   */
  resubmitForm(id: number): Observable<any> {
    return this.http
      .post(`${config.apiUrl1}parse_telehealth_form_json`, { telehealth_form_id: id })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  /**
   * Send telehealth form to staff
   * @param id The id to resubmit form
   * @returns Observable
   */
  sendFormToStaff(id: number): Observable<any> {
    return this.http
      .post(`${config.apiUrl1}send_telehealth_form_to_staff`, { telehealth_form_id: id })
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  /**
   * Send a manual "pending booking" reminder for an order that is waiting for info
   * @param orderId The order id to send the reminder for
   * @returns Observable
   */
  sendPendingBookingReminder(orderId: number): Observable<any> {
    return this.http
      .post(`${config.apiUrl1}orders/${orderId}/reminders/pending_booking`, {})
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  /**
   * Common method to show confirmation dialog and send a manual pending booking reminder.
   * Shared by the orders table row menu and the view-order "More" menu so the dialog
   * copy, API call, and success/error handling live in exactly one place.
   * @param orderId - The order ID to send the reminder for
   * @param onSuccess - Callback function to execute on successful send (optional)
   * @param onError - Callback function to execute on error (optional)
   * @param onCancel - Callback function to execute when dialog is cancelled (optional)
   */
  confirmSendManualReminder(
    orderId: number,
    onSuccess?: (res: any) => void,
    onError?: (error: any) => void,
    onCancel?: () => void
  ): void {
    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '350px',
      data: {
        headerText: 'Send Manual Reminder?',
        message: 'Are you sure you want to send a pending booking reminder to this patient?',
        confirmButtonText: 'Send',
        showCancelButton: true,
      },
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result === 1) {
        this.sendPendingBookingReminder(orderId).subscribe(
          res => {
            this.alertService.notifySuccess(res?.message || 'Reminder queued successfully');

            if (onSuccess) {
              onSuccess(res);
            }
          },
          err => {
            this.alertService.notifyError(err.error?.message || 'Unable to queue reminder');

            if (onError) {
              onError(err);
            }
          }
        );
      } else {
        if (onCancel) {
          onCancel();
        }
      }
    });
  }

  /**
   * Get all doctors for dropdown
   * @param id The id to resubmit form
   * @returns Observable
   */
  get_med_cert_doctors(): Observable<any> {
    return this.http.get(`${config.apiUrl1}get_med_cert_doctors`).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  /**
   * Generate medical certificate
   * @param id The id to resubmit form
   * @returns Observable
   */
  gen_med_cert(data): Observable<any> {
    return this.http.post(`${config.apiUrl1}generate_medical_cert`, data).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  getOrderCount(data: OrderCountRequest) {
    return this.http
      .post<{
        msg: string;
        count: number;
        status: number;
      }>(`${config.apiUrl1}get_order_count`, data)
      .pipe(
        catchError(err => {
          return throwError(err);
        })
      );
  }

  bulkChangeOrderStatus(orders: number[], from: string, to: BulkActionStatus) {
    return this.http
      .post(`${config.apiUrl1}bulk_actions_initialiser`, {
        type: 'Change Order Status',
        request_data: {
          orders,
          action_user: this.jwtAuth.getUser().id,
          from,
          to,
        },
      })
      .pipe(catchError(err => throwError(err)));
  }

  bulkSendComms(orders: number[], message: string) {
    return this.http
      .post(`${config.apiUrl1}bulk_actions_initialiser`, {
        type: 'Send Comms',
        request_data: {
          orders,
          message,
        },
      })
      .pipe(catchError(err => throwError(err)));
  }
  precheckoutOrder(payload: PrecheckoutOrderPayload) {
    return this.http
      .post<PrecheckoutAPIResponse>(`${config.apiUrl1}precheckout`, payload)
      .pipe(catchError(err => throwError(err)));
  }

  getActiveDeliveryPartners(payload: ActiveDeliveryPartnersPayload) {
    const params = createHttpParams(payload);
    return this.http.get<ActiveDeliveryPartnersApiResponse>(
      config.apiUrl1 + 'active_delivery_partners/estimates',
      { params }
    );
  }

  getOrderLinks(orderId: number) {
    return this.http
      .get<Link[]>(`${config.apiUrl1}orders/${orderId}/links`)
      .pipe(catchError(err => throwError(err)));
  }

  assignableMedications(request: PaginationRequest = {}) {
    const params = createHttpParams(request);
    return this.http
      .get<PaginatedData<AssignableMedication>>(`${config.apiUrl1}assignable_medications`, {
        params,
      })
      .pipe(catchError(err => throwError(err)));
  }

  assignMedicationToOrder(
    orderId: number,
    payload: AssignableMedicationPayloadWithEnv,
    env: Environment
  ) {
    if (config.env !== 'production') {
      payload.env = env;
    }
    return this.http
      .post<{ msg: string }>(`${config.apiUrl1}orders/${orderId}/assign_medication`, payload)
      .pipe(catchError(err => throwError(err)));
  }

  isTelehealthReferralOrder(surveyData: SurveyDataObj) {
    return ['Pharmacy-Telehealth-Request', 'Pharmacy-Quitmate-Request'].includes(
      surveyData.header.telehealth_type
    );
  }

  activateInactiveBasketItems(payload: ActivateInactiveBasketItemsPayload) {
    return this.http.post<ActivateInactiveBasketItemsResponse>(`${config.apiUrl1}activate_inactive_basket_items`, payload).pipe(
      catchError(err => {
        return throwError(err);
      })
    );
  }

  assignOrderToClinician(data: any): Observable<any> {
    const url = `${config.apiUrl1}clinician/assignOrder`;
    return this.http.post<any>(url, data);
  }

  updateClinicianShiftOrderStatus(data: any): Observable<any> {
    const url = `${config.apiUrl1}clinician_shift/updateShiftOrderStatus`;
    return this.http.post<any>(url, data);
  }

  updateStatus(data: any): Observable<any> {
    const url = `${config.apiUrl1}clinician_shift/updateStatus`;
    return this.http.post<any>(url, data);
  }

  getOrderStatusLabel(orderStatus: OrderStatus, hasPendingDataForm?: boolean): string {
    if (orderStatus === OrderStatusEnum.ClinicToUpdate && hasPendingDataForm) {
      return 'Additional Info Requested';
    }
    return ORDER_STATUS_LABEL_MAPPING[orderStatus] || orderStatus;
  }

  triggerOrdersAutoAllocation() {
    const url = `${config.apiUrl1}performOrdersAutoAllocation`;
    return this.http.get<OrdersAutoAllocationResponse>(url);
  }

  addPaperScriptLocation(data: AddPaperScriptLocationRequest) {
    const url = `${config.apiUrl1}addPaperScriptToPharmacy`;
    return this.http.post<AddPaperScriptLocationResponse>(url, data);
  }

  sendPaperScriptToPharmacy(orderId: number) {
    const url = `${config.apiUrl1}sendPaperScriptToPharmacy/${orderId}`;
    return this.http.get<AddPaperScriptLocationResponse>(url);
  }

  /**
   * Fetch active order sources from backend
   * Results are cached in BehaviorSubject for reuse across dropdowns
   */
  getOrderSources(): Observable<any[]> {
    // Return cached data if available
    if (this.cachedOrderSources.value.length > 0) {
      return this.cachedOrderSources.asObservable().pipe(take(1));
    }

    const url = `${environment.apiURL}getOrderSources`;
    return this.http.get<{ success: boolean; data: any[] }>(url).pipe(
      tap(response => {
        if (response.success && response.data) {
          this.cachedOrderSources.next(response.data);
        }
      }),
      switchMap(() => this.cachedOrderSources.asObservable().pipe(take(1))),
      catchError(error => {
        console.error('Failed to fetch order sources:', error);
        return of([]);
      })
    );
  }

  getFilters(role: ProfileType, status: OrdersTableStatus): Observable<any> {
    // Only fetch pharmacies for roles that need location filter
    const rolesWithLocationFilter = [
      ProfileType.Admin,
      ProfileType.SuperAdmin,
      ProfileType.BusinessUser,
      ProfileType.SuperBusinessUser
    ];
    const shouldFetchPharmacies = rolesWithLocationFilter.includes(role);

    return forkJoin({
      sources: this.getOrderSources(),
      pharmacies: shouldFetchPharmacies
        ? this.getPharmacyList({ statuses: '1,2,4,6' }).pipe(
          catchError(error => {
            console.error('Failed to fetch pharmacies for location filter:', error);
            return of([]); // Return empty array if pharmacy fetch fails
          })
        )
        : of([]), // Return empty array for roles that don't need location filter
      clinicians: this.jwtAuth.isAdmin()
        ? this.getCliniciansForFilter().pipe(
          catchError(error => {
            console.error('Failed to fetch clinicians for clinician filter:', error);
            return of([]);
          })
        )
        : of([]),
      filterConfig: this.systemSettingsService.getPortalFilterConfiguration().pipe(
        catchError(_ => {
          return of({ service_types: [], appointment_types: [], consult_statuses: [] });
        })
      )
    }).pipe(
      switchMap(({ sources, pharmacies, clinicians, filterConfig }) => {
        // Build source filter from API data - default all sources
        const COMMON_SOURCE_FILTER = {
          key: "source",
          label: "Source",
          multi: true,
          default: [],
          options: sources.map(s => ({
            value: s.key,
            label: s.display_name
          }))
        };

        // Build location filter from pharmacy data
        const COMMON_LOCATION_FILTER = {
          key: "locationId",
          label: "Location",
          multi: true,
          default: [],
          options: pharmacies.map(p => ({
            value: p.locationid,
            label: `${p.locationname} (ID: ${p.locationid})`,
            searchText: `${p.locationname} ${p.locationid}` // For search matching
          }))
        };

        const COMMON_CLINICIAN_FILTER = {
          key: "clinicianId",
          label: "Clinician",
          multi: false,
          default: '',
          options: clinicians
            ?.filter(c => c.status === 1)
            .map(c => ({
              value: c.id,
              label: c.name,
              searchText: `${c.name} ${c.id}`
            })) || []
        };

        return this.buildFiltersForRole(role, status, COMMON_SOURCE_FILTER, COMMON_LOCATION_FILTER, COMMON_CLINICIAN_FILTER, filterConfig);
      }),
      catchError(error => {
        console.error('Error in getFilters:', error);
        return of([]); // Return empty array if entire operation fails
      })
    );
  }

  private buildFiltersForRole(role: ProfileType, status: OrdersTableStatus, COMMON_SOURCE_FILTER: any, COMMON_LOCATION_FILTER: any, COMMON_CLINICIAN_FILTER: any, config: PortalFilterConfiguration): Observable<any> {
    // Build service type filter from API response
    const activeServiceTypes = config.service_types?.filter(st => st.is_active) || [];
    const COMMON_SERVICE_TYPE_FILTER = {
      key: "serviceType",
      label: "Service Type",
      multi: true,
      default: [],  // No default - user must explicitly select to apply filter
      options: activeServiceTypes.map(st => ({
        value: st.value,
        label: st.label
      }))
    };

    // Build consult status filter from API response
    const activeConsultStatuses = config.consult_statuses?.filter(cs => cs.is_active) || [];
    const COMMON_CONSULT_STATUS_FILTER = {
      key: "consultStatus",
      label: "Consult Status",
      multi: true,
      default: [],  // No default - user must explicitly select to apply filter
      options: activeConsultStatuses.map(cs => ({
        value: cs.value,
        label: cs.label
      }))
    };

    // Build appointment type filter from API response
    const activeAppointmentTypes = config.appointment_types?.filter(at => at.is_active) || [];
    const COMMON_APPOINTMENT_TYPE_FILTER = {
      key: "appointmentType",
      label: "Appointment Type",
      multi: true,
      default: [],  // No default - user must explicitly select to apply filter
      options: activeAppointmentTypes.map(at => ({
        value: at.value,
        label: at.label
      })),
      aliases: {
        "next_available": ["next_available", "Next Available"],
        "book_time": ["book_time", "Book A Time"],
        "priority": ["priority", "Priority"],
        "weight_loss": ["weight_loss"],
      }
    };

    const COMMON_PRIORITY_ESCALATION_FILTER = {
      key: "priorityEscalation",
      label: "Priority Escalation",
      multi: false,
      default: [true],
      hidden: true,
      options: [
        { value: true, label: "Priority Escalation" },
      ]
    };

    // COMMON_LOCATION_FILTER now passed as parameter from getFilters()

    // Clinician-specific filters (Doctor, Nurse, NursePractitioner)
    const CLINICIAN_CLINIC_TO_ACTION_FILTERS = [
      {
        key: "orderStatus",
        label: "Order Status",
        multi: true,
        default: [OrderStatusEnum.Completed, OrderStatusEnum.Cancelled, OrderStatusEnum.ClinicToAction],
        hidden: true,
        options: [
          { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
          { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled },
          { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction }
        ]
      },
      {
        key: "consultStatus",
        label: "Consult Status",
        multi: true,
        hidden: true,
        default: [OrderAssignStatusEnum.Assigned, OrderAssignStatusEnum.Started, OrderAssignStatusEnum.Paused],
        options: [
          { value: OrderAssignStatusEnum.Assigned, label: "Assigned" },
          { value: OrderAssignStatusEnum.Started, label: "Started" },
          { value: OrderAssignStatusEnum.Paused, label: "Paused" }
        ]
      },
    ];

    const CLINICIAN_COMPLETED_FILTERS = [
      {
        key: "orderStatus",
        label: "Order Status",
        multi: true,
        default: [OrderStatusEnum.PharmacyToReview, OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.RequestIssued, OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Process, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.PendingCancellation, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.Exception, OrderStatusEnum.PendingPayment, OrderStatusEnum.Return, OrderStatusEnum.Completed, OrderStatusEnum.Cancelled],
        hidden: true, // Don't show in UI, but send default values in payload
        options: [
          { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled },
          { value: OrderStatusEnum.PharmacyToReview, label: OrderStatusEnum.PharmacyToReview },
          { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
          { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
          { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
          { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
          { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
          { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
          { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
          { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
          { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
          { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
          { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
          { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
          { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
          { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
          { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation },
          { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
          { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
          { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
          { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return },
          { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
          { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
        ]
      },
      {
        key: "consultStatus",
        label: "Consult Status",
        multi: false,
        default: [OrderAssignStatusEnum.Completed],
        options: [
          { value: OrderAssignStatusEnum.Escalated, label: "Escalated" },
          { value: OrderAssignStatusEnum.Completed, label: "Completed" }
        ]
      }
    ];

    const COMMON_INCOMPLETE_INFO_FILTER = {
      key: "incompleteInfo",
      label: "Info Status",
      multi: false,
      default: [],
      options: [
        { value: true, label: "Incomplete Info" },
        { value: false, label: "Complete Info" }
      ]
    };

    const data = {
      [ProfileType.Admin]: {
        [OrdersTableStatus.ClinicToAction]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.WaitingRoom, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: "Clinic To Review" },
              { value: OrderStatusEnum.ClinicToAction, label: "Clinic To Action" },
              { value: OrderStatusEnum.ClinicToUpdate, label: "Clinic To Update" },
              { value: OrderStatusEnum.WaitingForInfo, label: "Waiting For Info" },
              { value: OrderStatusEnum.WaitingRoom, label: "Waiting Room" },
              { value: OrderStatusEnum.AutoAllocation, label: "Auto Allocation" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ClinicToReview]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.ClinicToReview],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview }
            ]
          },
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER],
        [OrdersTableStatus.ClinicToUpdate]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.ClinicToUpdate],
            options: [
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate }
            ]
          },
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER],
        [OrdersTableStatus.WaitingRoom]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.WaitingRoom],
            options: [
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.AutoAllocation]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ClinicToActionAdmin]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToAction],
            options: [
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
          COMMON_CLINICIAN_FILTER,
        ],
        [OrdersTableStatus.Escalation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Exception, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.New, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Rejected, OrderStatusEnum.PendingPayment, OrderStatusEnum.Process, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.RequestIssued, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToReview, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_PRIORITY_ESCALATION_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.WaitingForInformation]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.WaitingForInfo],
            options: [
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
          COMMON_INCOMPLETE_INFO_FILTER
        ],
        [OrdersTableStatus.RequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ProcessingAdmin]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.PendingCancellation],
            options: [
              {
                value: OrderStatusEnum.Process, label: OrderStatusEnum.Process,
              },
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Active]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.PharmacyToReview, OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.RequestIssued, OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Process, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.PendingCancellation, OrderStatusEnum.Return, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.AutoAllocation, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Returned],
            options: [
              { value: OrderStatusEnum.PharmacyToReview, label: OrderStatusEnum.PharmacyToReview },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Returned, label: OrderStatusEnum.Returned },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Exception]: [{
          key: "orderStatus",
          label: "Order Status",
          multi: true,
          default: [OrderStatusEnum.Exception, OrderStatusEnum.PendingPayment, OrderStatusEnum.Return],
          options: [
            { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
            { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
            { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
          ]
        },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingBatchProcessing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingBatchProcessing],
            options: [
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.CareCall]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Exception, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.New, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Rejected, OrderStatusEnum.PendingPayment, OrderStatusEnum.Process, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.RequestIssued, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToReview, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          {
            key: "source",
            label: "Source",
            multi: true,
            hidden: true,
            default: ["CareCall"],
            options: [
              { value: "CareCall", label: "Care Call" }
            ]
          },
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ]
      },
      [ProfileType.SuperAdmin]: {
        [OrdersTableStatus.ClinicToAction]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.WaitingRoom, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: "Clinic To Review" },
              { value: OrderStatusEnum.ClinicToAction, label: "Clinic To Action" },
              { value: OrderStatusEnum.ClinicToUpdate, label: "Clinic To Update" },
              { value: OrderStatusEnum.WaitingForInfo, label: "Waiting For Info" },
              { value: OrderStatusEnum.WaitingRoom, label: "Waiting Room" },
              { value: OrderStatusEnum.AutoAllocation, label: "Auto Allocation" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ClinicToReview]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.ClinicToReview],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview }
            ]
          },
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER],
        [OrdersTableStatus.ClinicToUpdate]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.ClinicToUpdate],
            options: [
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate }
            ]
          },
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER],
        [OrdersTableStatus.WaitingRoom]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.WaitingRoom],
            options: [
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.AutoAllocation]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ClinicToActionAdmin]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToAction],
            options: [
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
          COMMON_CLINICIAN_FILTER,
        ],
        [OrdersTableStatus.Escalation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Exception, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.New, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Rejected, OrderStatusEnum.PendingPayment, OrderStatusEnum.Process, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.RequestIssued, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToReview, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_PRIORITY_ESCALATION_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.WaitingForInformation]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.WaitingForInfo],
            options: [
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
          COMMON_INCOMPLETE_INFO_FILTER
        ],
        [OrdersTableStatus.RequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.ProcessingAdmin]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.PendingCancellation],
            options: [
              {
                value: OrderStatusEnum.Process, label: OrderStatusEnum.Process,
              },
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Active]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.PharmacyToReview, OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.RequestIssued, OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Process, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.PendingCancellation, OrderStatusEnum.Return, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.AutoAllocation, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Returned],
            options: [
              { value: OrderStatusEnum.PharmacyToReview, label: OrderStatusEnum.PharmacyToReview },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Returned, label: OrderStatusEnum.Returned },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Exception]: [{
          key: "orderStatus",
          label: "Order Status",
          multi: true,
          default: [OrderStatusEnum.Exception, OrderStatusEnum.PendingPayment, OrderStatusEnum.Return],
          options: [
            { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
            { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
            { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
          ]
        },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER],
        [OrdersTableStatus.PendingBatchProcessing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingBatchProcessing],
            options: [
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.CareCall]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Exception, OrderStatusEnum.BulkStatusTransition, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.New, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.Rejected, OrderStatusEnum.PendingPayment, OrderStatusEnum.Process, OrderStatusEnum.WaitingRoom, OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation, OrderStatusEnum.RequestIssued, OrderStatusEnum.ClinicToAction, OrderStatusEnum.ClinicToReview, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.Exception, label: OrderStatusEnum.Exception },
              { value: OrderStatusEnum.BulkStatusTransition, label: OrderStatusEnum.BulkStatusTransition },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.New, label: OrderStatusEnum.New },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.Rejected, label: OrderStatusEnum.Rejected },
              { value: OrderStatusEnum.PendingPayment, label: OrderStatusEnum.PendingPayment },
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          {
            key: "source",
            label: "Source",
            multi: true,
            hidden: true,
            default: ["CareCall"],
            options: [
              { value: "CareCall", label: "Care Call" }
            ]
          },
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER,
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ]
      },
      [ProfileType.PortalUser]: {
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
          COMMON_SOURCE_FILTER
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
        ]
      },
      [ProfileType.StandardPharmacy]: {
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
        ]
      },
      [ProfileType.SuperBusinessUser]: {
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ]
      },
      [ProfileType.BusinessUser]: {
        [OrdersTableStatus.PendingApproval]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.New, OrderStatusEnum.Rejected, OrderStatusEnum.PharmacyToReview],
            options: [
              { value: OrderStatusEnum.New, label: "New" },
              { value: OrderStatusEnum.Rejected, label: "Rejected" },
              { value: OrderStatusEnum.PharmacyToReview, label: "Pharmacy To Review" }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PriceRequest]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.WaitingForReview, OrderStatusEnum.AwaitingAuthorisation],
            options: [
              { value: OrderStatusEnum.WaitingForReview, label: OrderStatusEnum.WaitingForReview },
              { value: OrderStatusEnum.AwaitingAuthorisation, label: OrderStatusEnum.AwaitingAuthorisation }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Processing]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Process, OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.Process, label: OrderStatusEnum.Process },
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.DeliveryPickup]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit, OrderStatusEnum.AwaitingPickup, OrderStatusEnum.PendingBatchProcessing, OrderStatusEnum.PendingReturn, OrderStatusEnum.LeftAtLPO, OrderStatusEnum.Return],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
              { value: OrderStatusEnum.AwaitingPickup, label: OrderStatusEnum.AwaitingPickup },
              { value: OrderStatusEnum.PendingBatchProcessing, label: OrderStatusEnum.PendingBatchProcessing },
              { value: OrderStatusEnum.PendingReturn, label: OrderStatusEnum.PendingReturn },
              { value: OrderStatusEnum.LeftAtLPO, label: OrderStatusEnum.LeftAtLPO },
              { value: OrderStatusEnum.Return, label: OrderStatusEnum.Return }
            ]
          },
          COMMON_SOURCE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
          COMMON_CONSULT_STATUS_FILTER,
          COMMON_SERVICE_TYPE_FILTER,
          COMMON_SOURCE_FILTER,
          COMMON_APPOINTMENT_TYPE_FILTER,
          COMMON_LOCATION_FILTER
        ]
      },
      [ProfileType.Driver]: {
        [OrdersTableStatus.DeliveryPickupDriver]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.AwaitingDelivery, OrderStatusEnum.InTransit],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery },
              { value: OrderStatusEnum.InTransit, label: OrderStatusEnum.InTransit },
            ]
          },
        ]
      },
      [ProfileType.TelehealthPharmacy]: {
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthAwaitingDelivery]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.AwaitingDelivery],
            options: [
              { value: OrderStatusEnum.AwaitingDelivery, label: OrderStatusEnum.AwaitingDelivery }
            ]
          },
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
        ]
      },
      [ProfileType.ClinicalOperations]: {
        [OrdersTableStatus.TelehealthPending]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.ClinicToReview, OrderStatusEnum.ClinicToAction, OrderStatusEnum.WaitingRoom, OrderStatusEnum.ClinicToUpdate, OrderStatusEnum.WaitingForInfo, OrderStatusEnum.AutoAllocation],
            options: [
              { value: OrderStatusEnum.ClinicToReview, label: OrderStatusEnum.ClinicToReview },
              { value: OrderStatusEnum.ClinicToAction, label: OrderStatusEnum.ClinicToAction },
              { value: OrderStatusEnum.WaitingRoom, label: OrderStatusEnum.WaitingRoom },
              { value: OrderStatusEnum.ClinicToUpdate, label: OrderStatusEnum.ClinicToUpdate },
              { value: OrderStatusEnum.WaitingForInfo, label: OrderStatusEnum.WaitingForInfo },
              { value: OrderStatusEnum.AutoAllocation, label: OrderStatusEnum.AutoAllocation }
            ]
          },
        ],
        [OrdersTableStatus.TelehealthRequestIssued]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.RequestIssued],
            options: [
              { value: OrderStatusEnum.RequestIssued, label: OrderStatusEnum.RequestIssued }
            ]
          },
        ],
        [OrdersTableStatus.Completed]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            default: [OrderStatusEnum.Completed],
            options: [
              { value: OrderStatusEnum.Completed, label: OrderStatusEnum.Completed },
            ]
          },
        ],
        [OrdersTableStatus.Cancelled]: [
          {
            key: "orderStatus", label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.Cancelled],
            options: [
              { value: OrderStatusEnum.Cancelled, label: OrderStatusEnum.Cancelled }
            ]
          },
        ],
        [OrdersTableStatus.PendingCancellation]: [
          {
            key: "orderStatus",
            label: "Order Status",
            multi: true,
            hidden: true,
            default: [OrderStatusEnum.PendingCancellation],
            options: [
              { value: OrderStatusEnum.PendingCancellation, label: OrderStatusEnum.PendingCancellation }
            ]
          },
        ]
      },
      [ProfileType.Doctor]: {
        [OrdersTableStatus.ClinicToAction]: CLINICIAN_CLINIC_TO_ACTION_FILTERS,
        [OrdersTableStatus.Completed]: CLINICIAN_COMPLETED_FILTERS
      },
      [ProfileType.NursePractitioner]: {
        [OrdersTableStatus.ClinicToAction]: CLINICIAN_CLINIC_TO_ACTION_FILTERS,
        [OrdersTableStatus.Completed]: CLINICIAN_COMPLETED_FILTERS
      },
      [ProfileType.Nurse]: {
        [OrdersTableStatus.ClinicToAction]: CLINICIAN_CLINIC_TO_ACTION_FILTERS,
        [OrdersTableStatus.Completed]: CLINICIAN_COMPLETED_FILTERS
      },
    };
    // Not every role/screen pair has an entry — Admin has no key for
    // pending_approval_in_store or deliverypickup_driver. Emit an empty list so
    // consumers get an array rather than undefined.
    return of(data[role]?.[status] ?? []);
  }





  /**
   * Check if the consult is still active (assigned, started, or paused)
   * @param orderAssignStatus The order assignment status to check
   * @returns true if consult is active, false otherwise
   */
  isConsultActive(orderAssignStatus: OrderAssignStatusEnum): boolean {
    const activeStatuses = [
      OrderAssignStatusEnum.Assigned,
      OrderAssignStatusEnum.Started,
      OrderAssignStatusEnum.Paused
    ];
    return activeStatuses.includes(orderAssignStatus);
  }

  /**
   * Show dialog when trying to cancel/refund/complete an order with active consult
   * @param action The action type: 'cancel', 'refund', or 'complete'
   */
  showConsultActiveDialog(action: 'cancel' | 'refund' | 'complete' = 'cancel'): void {
    const messages = {
      cancel: 'Consult is still active, please unassign the clinician before cancelling the order.',
      refund: 'Consult is still active, please unassign the clinician before refunding the order.',
      complete: 'Order cannot be completed. The consultation must be completed or unassigned before proceeding.'
    };

    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '450px',
      data: {
        headerText: 'Consult is Still Active',
        message: messages[action],
        confirmButtonText: 'Okay',
        showCancelButton: false
      } as ConfirmationDialogData,
    });

    dialogRef.afterClosed().subscribe(() => {
      // Dialog closed, no action needed
    });
  }

  private hasServiceProfileMismatch(
    orderServiceProfiles?: number[] | null,
    clinicianServiceProfiles?: number[] | null
  ): boolean {
    const orderProfiles = (orderServiceProfiles ?? []).filter(
      (id): id is number => id !== null && id !== undefined
    );

    if (orderProfiles.length === 0) {
      return false;
    }

    const clinicianProfiles = new Set(
      (clinicianServiceProfiles ?? []).filter(
        (id): id is number => id !== null && id !== undefined
      )
    );

    if (clinicianProfiles.size === 0) {
      return true;
    }

    return !orderProfiles.some(profileId => clinicianProfiles.has(profileId));
  }

  confirmClinicianAssignmentByServiceProfile(
    orderServiceProfiles?: number[] | null,
    clinicianServiceProfiles?: number[] | null
  ): Observable<boolean> {
    if (!this.hasServiceProfileMismatch(orderServiceProfiles, clinicianServiceProfiles)) {
      return of(true);
    }

    const dialogRef = this.dialog.open(DialogConfirmationComponent, {
      width: '520px',
      data: {
        headerText: 'Service Profile Mismatch',
        message:
          'The clinician you are assigning to this consult does not have the correct training.<br><br>' +
          'Please check before proceeding.<br><br>' +
          'If the consult cannot be carried out, please contact the patient to re-schedule.<br><br>' +
          'Do you still want to assign the order to this clinician?',
        confirmButtonText: 'Assign Clinician',
        showCancelButton: true,
      } as ConfirmationDialogData,
    });

    return dialogRef.afterClosed().pipe(
      take(1),
      switchMap(result => of(result === 1))
    );
  }

  /**
   * Check if we should capture a reason when moving to Waiting Room
   * @param currentOrderAssignStatus Current order assignment status
   * @returns true if the previous consult was completed
   */
  shouldCaptureWaitingRoomReason(currentOrderAssignStatus: OrderAssignStatusEnum): boolean {
    return currentOrderAssignStatus === OrderAssignStatusEnum.Completed;
  }

  /**
   * Show dialog to capture reason for moving back to Waiting Room
   * @param orderId The order ID
   * @param currentStatus Current order status
   * @param toStatus Target status (should be Waiting Room)
   * @param onSuccess Callback function on successful status change
   * @param onError Callback function on error
   * @param onCancel Callback function when dialog is cancelled
   */
  showWaitingRoomReasonDialog(
    orderId: number,
    currentStatus: string,
    toStatus: string,
    onSuccess: () => void,
    onError: () => void,
    onCancel: () => void
  ): void {
    const dialogRef = this.dialog.open(DialogWaitingRoomReasonComponent, {
      width: '500px',
      disableClose: true,
      data: {
        title: 'Reason for Moving Back to Waiting Room',
        message: 'The previous consultation was completed. Please provide a reason for moving this order back to the waiting room:'
      }
    });

    dialogRef.afterClosed().subscribe((result: WaitingRoomReasonResult) => {
      if (result) {
        let reasonToSend = result.reason;
        if (result.reasonText) {
          reasonToSend = `${result.reason} - ${result.reasonText}`;
        }

        this._changeOrderStatus(orderId, currentStatus, toStatus, reasonToSend)
          .subscribe(
            res => {
              this.alertService.notifySuccess(res.msg);
              onSuccess();
            },
            err => {
              this.alertService.notifyError(err.error.msg || 'An unknown error occurred.');
              onError();
            }
          );
      } else {
        onCancel();
      }
    });
  }

  /**
   * Opens the Pending Cancellation action dialog (Complete / Waiting Room / Cancel).
   * On Cancel: opens the cancellation-reason dialog and calls _changeOrderStatus.
   *   - For HE orders: passes { refund: userChoice } flag instead of initiateRefund().
   * On Complete / Waiting Room: calls _changeOrderStatus directly, then fires onSuccess.
   */
  openPendingCancellationActionDialog(params: {
    orderId: number;
    fromStatus: string;
    source?: string;
    orderPaidAmount?: string;
    preselectedAction?: 'cancel' | 'complete' | 'waitingRoom';
    onSuccess?: () => void;
  }): void {
    const isHEOrder = !!params.source?.includes(SourceEnum.HEALTH_ENGINE);

    const dialogRef = this.dialog.open(PendingCancellationActionDialogComponent, {
      width: '400px',
      maxWidth: '400px',
      disableClose: true,
      data: {
        preselectedAction: params.preselectedAction,
      } as PendingCancellationActionData,
    });

    dialogRef.afterClosed().subscribe((result: PendingCancellationActionResult | null) => {
      if (!result) return;

      if (result.action === 'cancel') {
        // Open cancellation-reason dialog; it handles the API call internally.
        // For HE orders, useRefundFlag=true routes refund through _changeOrderStatus instead of initiateRefund()
        this.dialog.open(DialogCancelOrderComponent, {
          width: '400px',
          maxWidth: '400px',
          data: {
            refundAmount: params.orderPaidAmount,
            orderid: params.orderId,
            currentStatus: params.fromStatus,
            toStatus: OrderStatusEnum.Cancelled,
            isRejectOrder: false,
            useRefundFlag: isHEOrder,
          } as CancelOrderDialogData,
        });
        // DialogCancelOrderComponent handles success/error + page reload internally.
      } else {
        const toStatus = result.action === 'complete'
          ? OrderStatusEnum.Completed
          : OrderStatusEnum.ClinicToAction;

        this._changeOrderStatus(params.orderId, params.fromStatus, toStatus, '')
          .subscribe(
            res => {
              this.alertService.notifySuccess(res.msg);
              if (params.onSuccess) params.onSuccess();
            },
            err => {
              this.alertService.notifyError(err.error?.msg || 'An unexpected error occurred');
            }
          );
      }
    });
  }

  /**
   * Format most recent note for display in orders table
   * Use the generic formatNotes(noteType, notesString) method directly
   * @deprecated Use formatNotes(noteType, notesString) instead
   */

  /**
   * Get user chat role based on their authentication
   */
  getUserChatRole(): string {
    if (this.jwtAuth.isAdmin()) {
      return 'Support';
    } else if (this.jwtAuth.isClinician()) {
      return 'Clinician';
    } else {
      return 'User';
    }
  }

  /**
   * Get clinician section visibility and edit state based on order status
   * @param orderStatus Current order status
   * @returns Object with visible and readOnly flags
   */
  getClinicianSectionState(orderStatus: OrderStatus): { visible: boolean; readOnly: boolean } {
    const visibleStatuses = [
      // OrderStatusEnum.ClinicToReview,
      OrderStatusEnum.ClinicToUpdate,
      OrderStatusEnum.WaitingRoom,
      OrderStatusEnum.AutoAllocation,
      OrderStatusEnum.ClinicToAction,
      // OrderStatusEnum.WaitingForInfo,
      OrderStatusEnum.RequestIssued,
      OrderStatusEnum.Completed,
      OrderStatusEnum.Cancelled
    ];

    const readOnlyStatuses = [
      OrderStatusEnum.Completed,
      OrderStatusEnum.Cancelled
    ];

    const visible = visibleStatuses.includes(orderStatus as any);
    const readOnly = readOnlyStatuses.includes(orderStatus as any);

    return { visible, readOnly };
  }

  /**
   * Check if clinician details should be visible
   * @param orderStatus Current order status
   * @returns boolean indicating if clinician details should be visible
   */
  shouldShowClinicianDetails(orderStatus: OrderStatus): boolean {
    return this.jwtAuth.isAdmin() && this.getClinicianSectionState(orderStatus).visible;
  }

  /**
   * 
   * @param orderStatus Current order status
   * @returns boolean indicating if clinician notes are read-only
   */
  isClinicianNotesReadOnly(orderStatus: OrderStatus): boolean {
    // Allow both admins and clinicians to add notes
    const canEdit = this.jwtAuth.isAdmin() || this.jwtAuth.isClinician();
    return !canEdit || this.getClinicianSectionState(orderStatus).readOnly;
  }

  /**
 * 
 * @param orderStatus Current order status
 * @returns boolean indicating if clinician notes are visible
 */
  isClinicianNotesVisible(orderStatus: OrderStatus): boolean {
    return (this.jwtAuth.isAdmin() || this.jwtAuth.isClinician()) && this.getClinicianSectionState(orderStatus).visible;
  }

  /**
   * Open add clinician note dialog
   * @param element Order data
   * @param onSuccess Success callback to refresh data
   */
  /**
   * Configuration for different note types
   */
  private getNoteConfig(noteType: NoteType) {
    const configs = {
      clinician: {
        dbField: 'clinician_notes',
        title: null, // Let component handle default behavior
        suggestions: null, // Let component handle default behavior
        successMessage: 'Clinician notes updated successfully',
        errorMessage: 'Failed to update clinician notes'
      },
      owner: {
        dbField: 'currentOwner',
        title: 'Add Owner Note',
        suggestions: [],
        successMessage: 'Owner notes updated successfully',
        errorMessage: 'Failed to update owner notes'
      },
      admin: {
        dbField: 'apn',
        title: 'Add Admin Note',
        suggestions: [],
        successMessage: 'Admin notes updated successfully',
        errorMessage: 'Failed to update admin notes'
      },
      pharmacy: {
        dbField: 'ppn',
        title: 'Add Pharmacy Note',
        suggestions: [],
        successMessage: 'Pharmacy notes updated successfully',
        errorMessage: 'Failed to update pharmacy notes'
      }
    };
    return configs[noteType];
  }

  /**
   * Generic method to open add note dialog for any note type
   * @param noteType Type of note (clinician, owner, admin, pharmacy)
   * @param existingNotes Existing notes string
   * @param orderId Order ID
   * @param onSuccess Success callback
   */
  openAddNoteDialog(noteType: NoteType, existingNotes: string, orderId: number, onSuccess?: () => void) {
    const config = this.getNoteConfig(noteType);

    const dialogData: any = {
      existingNotes: existingNotes || '',
      orderId: orderId
    };

    // Add title and suggestions if configured
    if (config.title) {
      dialogData.dialogTitle = config.title;
    }
    if (config.suggestions !== null) {
      dialogData.quickSuggestions = config.suggestions;
    }

    const dialogRef = this.dialog.open(AddClinicianNoteComponent, {
      width: '400px',
      maxWidth: '400px',
      data: dialogData,
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.updateNotes(noteType, orderId, result, onSuccess);
      }
    });
  }

  /**
   * MT-1110: telehealth pharmacy dispenses a Request Issued order. Pickup orders complete straight
   * away; delivery orders complete if a tracking link is added now, otherwise they wait in
   * Awaiting Delivery for the delivery team to add one.
   */
  dispenseTelehealthOrder(order: TrackingLinkOrder, onDone: () => void) {
    if (order.isPickup) {
      this.changeStatusAfterDispense(order, OrderStatusEnum.RequestIssued, OrderStatusEnum.Completed, onDone);
      return;
    }

    this.openTrackingLinkDialog({
      headerText: 'Dispense Order',
      message: 'Add the delivery tracking number or link to complete this order, or dispense now and add it later.',
      skipButtonText: 'Add Link Later',
    }).subscribe(result => {
      if (result === TRACKING_LINK_SKIPPED) {
        this.changeStatusAfterDispense(order, OrderStatusEnum.RequestIssued, OrderStatusEnum.AwaitingDelivery, onDone);
      } else if (result) {
        this.saveTrackingLinkAndComplete(order, OrderStatusEnum.RequestIssued, result, onDone);
      }
    });
  }

  // MT-1110: delivery team adds the tracking link to an Awaiting Delivery order, which completes it
  addTrackingLinkAndComplete(order: TrackingLinkOrder, onDone: () => void) {
    this.openTrackingLinkDialog({}).subscribe(link => {
      if (link && link !== TRACKING_LINK_SKIPPED) {
        this.saveTrackingLinkAndComplete(order, OrderStatusEnum.AwaitingDelivery, link, onDone);
      }
    });
  }

  private openTrackingLinkDialog(data: TrackingLinkDialogData): Observable<string | null> {
    return this.dialog
      // wider when the skip button is shown so all three actions fit on one line
      .open(DialogTrackingLinkComponent, { width: data.skipButtonText ? '480px' : '400px', disableClose: true, data })
      .afterClosed();
  }

  private saveTrackingLinkAndComplete(order: TrackingLinkOrder, fromStatus: string, link: string, onDone: () => void) {
    const data = { myuserid: order.userId, orderid: order.orderId, updateDeliveryTrackingLink: link };
    this._editOrder(data).subscribe(
      () => this.changeStatusAfterDispense(order, fromStatus, OrderStatusEnum.Completed, onDone),
      () => this.alertService.notifyError('Unable to save delivery tracking link. Please try again.')
    );
  }

  private changeStatusAfterDispense(order: TrackingLinkOrder, fromStatus: string, toStatus: string, onDone: () => void) {
    this._changeOrderStatus(order.orderId, fromStatus, toStatus, '').subscribe(
      res => {
        this.alertService.notifySuccess(res.msg);
        onDone();
      },
      err => this.alertService.notifyError(err.error?.msg || 'Unable to update the order status.')
    );
  }

  /**
   * Generic method to update notes for any note type
   * @param noteType Type of note (clinician, owner, admin, pharmacy)
   * @param orderId Order ID
   * @param notes Updated notes string
   * @param onSuccess Success callback
   * @param onError Error callback
   */
  updateNotes(noteType: NoteType, orderId: number, notes: string, onSuccess?: () => void, onError?: () => void) {
    const config = this.getNoteConfig(noteType);

    const data = {
      myuserid: this.jwtAuth.getUser().id,
      orderid: orderId,
      updateNotes: {
        [config.dbField]: notes
      }
    };

    this._editOrder(data).subscribe(
      res => {
        this.alertService.notifySuccess(config.successMessage);
        if (onSuccess) {
          onSuccess();
        }
      },
      err => {
        this.alertService.notifyError(config.errorMessage);
        if (onError) {
          onError();
        }
      }
    );
  }

  /**
   * Generic method to format notes for display (showing most recent note)
   * Backend format: {note: string, author: string, userId: number, timestamp: string, isLegacy: boolean}
   * @param noteType Type of note (clinician, owner, admin, pharmacy)
   * @param notesString JSON string of notes array
   * @returns Formatted HTML string of the most recent note
   */
  formatNotes(noteType: NoteType, notesString: string): string {
    if (!notesString) {
      return '';
    }

    try {
      const notesArray = JSON.parse(notesString);
      if (!Array.isArray(notesArray) || notesArray.length === 0) {
        return '';
      }

      // First note is always the most recent (backend adds with unshift)
      const noteObj = notesArray[0];

      // Backend returns: {note, author, userId, timestamp, isLegacy}
      if (noteObj.timestamp && !noteObj.isLegacy) {
        const relativeTime = utcToRelativeTime(noteObj.timestamp);
        const exactTime = utcToExactTime(noteObj.timestamp);
        return `<div class="recent-note"><strong>${noteObj.author}</strong> (<span title="${exactTime}">${relativeTime}</span>)<br>${noteObj.note || noteObj.message}</div>`;
      } else {
        // Legacy notes without proper timestamps
        return `<div class="recent-note">${noteObj.note || noteObj.message}</div>`;
      }
    } catch (error) {
      console.error(`Error parsing ${noteType} notes:`, error);
      return notesString; // Return as-is if parsing fails
    }
  }

  /**
   * Check if "Change BAT Appointment" option should be shown
   * This option allows rebooking a BAT appointment with a different date/time
   * 
   * @param orderData The order data object - can be from orders table or view orders
   * @param surveyData Optional survey data (for orders table it's in orderData.survey_data)
   * @returns true if order is a BAT telehealth appointment that can be rebooked
   */
  shouldShowChangeBatAppointment(orderData: any, surveyData?: SurveyDataObj): boolean {

    const validStatuses = [
      OrderStatusEnum.ClinicToReview,
      OrderStatusEnum.ClinicToAction,
      OrderStatusEnum.WaitingRoom,
      OrderStatusEnum.WaitingForInfo,
      OrderStatusEnum.AutoAllocation,
      OrderStatusEnum.RequestIssued
    ];
    const status = orderData.orderStatus || orderData.orderstatus;

    const excludedConsultStatuses = [
      OrderAssignStatusEnum.Started,
      OrderAssignStatusEnum.Paused,
      OrderAssignStatusEnum.Completed
    ];

    if (!validStatuses.includes(status) || excludedConsultStatuses.includes(orderData?.order_assign_status)) {
      return false;
    }

    // Must be "book_time" or "Book A Time" appointment type (DB has both formats)
    const bookingType = surveyData?.header?.booking_type;
    return bookingType === 'book_time' || bookingType === TELEHEALTH_BOOKING_TYPE.book_time;
  }

  /**
   * Check if "Change to Book A Time" option should be shown
   * This option allows converting a Next Available appointment to Book A Time
   * 
   * @param orderData The order data object - can be from orders table or view orders
   * @param surveyData Optional survey data (for orders table it's in orderData.survey_data)
   * @returns true if order is a Next Available telehealth appointment that can be converted
   */
  shouldShowChangeNaToBat(orderData: any, surveyData?: SurveyDataObj): boolean {

    const validStatuses = [
      OrderStatusEnum.ClinicToReview,
      OrderStatusEnum.ClinicToAction,
      OrderStatusEnum.WaitingRoom,
      OrderStatusEnum.WaitingForInfo,
      OrderStatusEnum.AutoAllocation,
      OrderStatusEnum.RequestIssued
    ];
    const status = orderData.orderStatus || orderData.orderstatus;

    const excludedConsultStatuses = [
      OrderAssignStatusEnum.Started,
      OrderAssignStatusEnum.Paused,
      OrderAssignStatusEnum.Completed
    ];

    if (!validStatuses.includes(status) || excludedConsultStatuses.includes(orderData?.order_assign_status)) {
      return false;
    }

    // Must be "next_available" or "Next Available" appointment type (DB has both formats)
    const bookingType = surveyData?.header?.booking_type;
    return bookingType === 'next_available' || bookingType === TELEHEALTH_BOOKING_TYPE.next_available;
  }

  /**
   * Open dialog to manage appointment changes (reschedule BAT or convert NA to BAT)
   * This method is shared between orders-table and view-orders components
   * 
   * @param orderId Order ID to manage
   * @param action The action label from AdditionalActions (e.g., 'Reschedule Book A Time Appointment')
   * @param onSuccess Callback function to execute after successful appointment change
   */
  openManageAppointmentDialog(orderId: number, action: AdditionalActionsType, onSuccess: () => void): void {
    const dialogRef = this.dialog.open(DialogCreateFollowUpRequestComponent, {
      width: '90%',
      maxWidth: '1300px',
      data: {
        orderId: orderId,
        action: action
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        onSuccess();
      }
    });
  }

  getSubscriptionTypes(orderId: number): Observable<{ value: string; label: string; defaultCadenceDays: number | null; defaultFollowupLeadDays: number | null; showCadenceToClinician: boolean; programDefaultCadenceDays: number | null }[]> {
    const params = createHttpParams({ order_id: orderId });
    return this.http
      .get<{ id: number; type: string; display_name: string; default_cadence_days: number | null; default_followup_lead_days?: number | null; show_cadence_to_clinician?: boolean; program_default_cadence_days?: number | null }[]>(
        environment.apiURL1 + 'subscription/types', { params }
      )
      .pipe(
        map(res => res.map(t => ({
          value: String(t.id),
          label: t.display_name,
          defaultCadenceDays: t.default_cadence_days,
          defaultFollowupLeadDays: t.default_followup_lead_days ?? null,
          // Manage Programs config for this dose's program type. Absent (dose
          // with no program type) -> show the picker, the pre-config default.
          showCadenceToClinician: t.show_cadence_to_clinician ?? true,
          programDefaultCadenceDays: t.program_default_cadence_days ?? null,
        }))),
        catchError(err => throwError(err))
      );
  }
}
